import { ActivityModel } from 'core/models/activity.model';

/**
 * @class Defines an activity session.
 */
export class ActivitySessionModel {
  /**
   * @constructor Creates an instance of an activity session built from an original data from the API.
   * @param {bo} bo is the basic object come from API.
   */
  constructor(bo) {
    this.id = bo.activity_session_id;
    this.activity = new ActivityModel(bo.activity);
    this.capsuleId = bo?.capsule_id;
    this.courseSessionId = bo?.course_session_id;
    this.contextCollectionTitle = bo?.context_collection_title;
    this.contextCultureName = bo.context_culture_name;
    this.socialNetworkLink = bo?.social_networks?.[0]?.url
      ? bo.social_networks[0]
      : null;
    this.pseudo = bo.pseudo;
    this.resumeSession = bo.resume_session;
    this.isNotTestSession =
      bo?.capsule_id !== null ||
      bo?.course_session_id !== null ||
      bo.working_session_id !== '00000000-0000-0000-0000-000000000000';
    this.workingSessionId = bo.working_session_id;
  }
}
